import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  id: string;
  businessSectionId: string;
};

const request = ({ id, businessSectionId }: RequestDataType) => {
  return new ApiClient()
    .delete<ResponseMessageType>(
      `/api/managers/business_sections/${businessSectionId}/business_section_competency_reviews/${id}`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersBusinessSectionsBusinessSectionCompetencyReviewsDestroy =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ResponseMessageType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
